module.exports = __webpack_public_path__ + "img/havanna_oak_694m_detail_rsh.f3e6e9b8.jpg";